import state from './state.groups'
import mutations from './mutations.groups'
import actions from './actions.groups'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}